export enum SeparatorType {
  Line = 'line',
  Dot = 'dot',
  ContentHomeLine = 'ContentHomeLine',
  ContentHomeListLine = 'ContentHomeListLine',
  ContentHomeDot = 'contentHomeDot',
}
